export default "__VITE_ASSET__d1c9a77c__"